import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import * as Icons from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import config from "../../config";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Widget from "../../components/Widget/Widget";
import Table from "../dashboard/components/Table/Table";
import Modal from "../modals/Modal";
import { debounce } from "lodash";

const useStyles = makeStyles(theme => ({
  tableOverflow: {
    overflow: 'auto'
  },
  tableWidget: {
    overflowX: "auto",
  },
  input: {
    border: '0px',
    backgroundColor: "#FFFFFF",
    padding: '12px',
    width: '350px',
    outlineColor: "#FFFFFF",
    borderRadius: '100px',
  },
  divHeader: {
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    marginBottom: '24px',
  },
  div: {
    height: '50px',
    width: '410px',
    backgroundColor: "#FFFFFF",
    padding: '6px',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
    boxShadow: theme.customShadows.widgetBlack,
  },
  divSearch: {
    height: '50px',
    width: '53px',
    padding: '2px',
    backgroundColor: "#FFFFFF",
    borderRadius: '100px',
  },
  divAddButton: {
    height: '50px',
    width: '50px',
    backgroundColor: "#FFFFFF",
    color: "#000000",
    marginLeft: '24px',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
    boxShadow: theme.customShadows.widgetBlack,
  },
  searchIcon: {
    borderRadius: '100px',
    padding: '8px',
    height: '100%',
    width: '100%',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    color: "#000000",
    transition: theme.transitions.create("right"),
    "&:hover, &:focus": {
      cursor: "pointer",
      backgroundColor: "#F4F4F4",
      color: "#000000"
    }
  },
}))

export default function Tables() {
  const classes = useStyles();
  const history = useHistory();

  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [accumulatedItems, setAccumulatedItems] = useState(0);
  const [itemsOnPage, setItemsOnPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [isSearch, setIsSearch] = useState(false);

  const closeModalLogin = e => {
    setShowModal(false);
  }

  const delayedHandleChange = debounce(search => {
    if (search != '') {
      setIsSearch(true);
      fetch(config.config[0].baseUrl + 'searchPartnerList/' + search,
      {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
      }
    ).then((res) => res.json())
      .then((json) => {
        setFilteredData(json);
      });
    } else {
      setIsSearch(false);
      setFilteredData(allData);
    }
    
  }, 700);

  const handleChange = (e) => {
    delayedHandleChange(e.target.value.toLowerCase());
  }

  const onNextPage = e => {
    if (currentPage < totalPages) {
      fetch(baseUrl + 'partners/page/' + currentPage,
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          const newData = data.content;

          if (newData != null) {
            setAllData(newData);
            setFilteredData(newData);
            setTotalPages(data.totalPages);
            setCurrentPage(data.number + 1);
            setAccumulatedItems(accumulatedItems + data.numberOfElements);
            setItemsOnPage(data.numberOfElements);
            setTotalItems(data.totalElements);
          } else {
            setShowModal(true);
          }
        }).catch(error => null);
    }
  }

  const onPreviousPage = e => {
    if (currentPage > 1) {
      fetch(baseUrl + 'partners/page/' + (currentPage - 2),
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          const newData = data.content;

          if (newData != null) {
            setAllData(newData);
            setFilteredData(newData);
            setTotalPages(data.totalPages);
            setCurrentPage(data.number + 1);
            setAccumulatedItems(accumulatedItems - itemsOnPage);
            setItemsOnPage(data.numberOfElements);
            setTotalItems(data.totalElements);
          } else {
            setShowModal(true);
          }
        }).catch(error => null);
    }
  }

  const onClickRow = (property) => (event) => {
    localStorage.setItem('partnerInfo', property);
    history.push({
      pathname: '/app/partnerInfo',
      state: { id: property }
    });
  };

  const onOpen = (property) => (event) => {
    const newBody = {
      idUser: property
    };

    fetch(baseUrl + "postOpenFromWeb",
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
        body: JSON.stringify(newBody)
      }).then(response => response.json())
      .then(data => {
        if (data.error != null) {
          setShowModal(true);
        } else { }
      })
      .catch(error => null);
  };

  const fechPartners = async () => {
    fetch(baseUrl + 'partners/page/' + 0,
      {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
      }).then(response => response.json())
      .then(data => {
        const newData = data.content;

        if (newData != null) {
          setAllData(newData);
          setFilteredData(newData);
          setTotalPages(data.totalPages);
          setAccumulatedItems(data.numberOfElements);
          setItemsOnPage(data.numberOfElements);
          setTotalItems(data.totalElements);
          if (data.numberOfElements == 0) {
            setCurrentPage(0);
          }
        } else {
          setTotalPages(0);
          setCurrentPage(0);
          setShowModal(true);
        }
      })
      .catch(error => null);
  }

  useEffect(() => {
    fechPartners();
  }, []);

  return (
    <>
      <div>
        {showModal ? (
          <Modal
            isOpen={showModal}
            closeModal={closeModalLogin}
          />
        ) : (
          <></>
        )}
        <PageTitle title="Socios" />

        <div className={classes.divHeader} >
          <div className={classes.div} >
            <input
              className={classes.input}
              type="text"
              onChange={(event) => handleChange(event)}
            />
            <div className={classes.divSearch} >
              <Icons.Search classes={{ root: classes.searchIcon }} />
            </div>
          </div>

          <div className={classes.divAddButton} >
            <Icons.Add classes={{ root: classes.searchIcon }}
              onClick={() =>
                history.push('/app/addPartner')
              }
            />
          </div>
        </div>

        <Grid item xs={12} style={{marginBottom: "30px"}}>
          <Widget
            noBodyPadding
            bodyClass={classes.tableWidget}
          >
            <Table
              data={filteredData}
              currentPage={currentPage}
              totalPages={totalPages}
              onPreviousPage={onPreviousPage}
              onNextPage={onNextPage}
              onClick={onClickRow}
              accumulatedItems={accumulatedItems}
              totalItems={totalItems}
              isSearch={isSearch}
              onOpen={onOpen}
            />
          </Widget>
        </Grid>
      </div>
    </>
  );
}
